import { $, $$ } from '../utils/dom';
import anime from '../../../node_modules/animejs/lib/anime.es.js';

// https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
const shuffle = array => {
  let currentIndex = array.length;
  let randomIndex;
  
  while (currentIndex > 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

const splitToNChunks = (array, n) => {
  let result = [];
  for (let i = n; i > 0; i--) {
      result.push(array.splice(0, Math.ceil(array.length / i)));
  }
  return result;
}

const randomElement = array => {
  return array[Math.floor(Math.random() * array.length)];
}

const addClassWithTimeout = (pathArray, timeout) => {

  const modifiersArray = [1, 2, 3];
  
  pathArray.forEach((paths, i) => {
    const modifier = randomElement(modifiersArray);
    setTimeout(() => {
      paths.forEach(path => {
        path.classList.add(`path--visible-${modifier}`)
      });
      }, i * timeout)
  })
}

let heroImage = $('.hero__image');

if (heroImage) {
  document.onreadystatechange = function() {
    if (document.readyState === 'complete') {
      heroImage.classList.remove('is-loading');
    }
  };
  
  let paths = $$('.hero__image path');

  shuffle(paths);

  const pathChunks = splitToNChunks([...paths], 100);
  
  const attrObserver = new MutationObserver((mutations, callback) => {
    mutations.forEach(mu => {
      if (mu.type !== 'attributes' && mu.attributeName !== 'class') return;
      callback;
    });
  });
  
  attrObserver.observe(heroImage, { attributes: true }, addClassWithTimeout(pathChunks, 150));

  setInterval(() => {
    if (paths.length === 0) return;
      anime({
        targets: paths.shift(),
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: function() { return anime.random(1000, 2000); },
        delay: function() { return anime.random(100, 200); },
        direction: 'alternate',
        loop: true
      });
  }, 25);
}
